// extracted by mini-css-extract-plugin
module.exports = {"wrap":"customerEdit_wrap__x8C3X","leftMenu":"customerEdit_leftMenu__1X3qP","rightContent":"customerEdit_rightContent__13cCK","formLabelDesc":"customerEdit_formLabelDesc__1Iu4W"};